<template>
  <div id="promocodes-alert" v-if="isShow">
    <div class="row g-2 align-items-center">
      <div class="mt-2" v-show="fields.newCnt > 0">
        <div class="alert alert-dismissible alert-info" role="alert" @click="onShowNew()">
          <div class="d-flex">
            Новые: {{ fields.newCnt }}
          </div>
        </div>
      </div>
      <div class="mt-2" v-show="fields.deleteCnt > 0">
        <div class="alert alert-dismissible alert-danger" role="alert" @click="onShowDelete()">
          <div class="d-flex">
            На удаление: {{ fields.deleteCnt }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref, watch} from "vue"
import {useRouter} from "vue-router/dist/vue-router"

const isShow = ref(false)

const router = useRouter()

const props = defineProps({
  payload: {
    type: Object,
    default: () => ({}),
  },
})

const fields = reactive({
  newCnt: 0,
  deleteCnt: 0,
})

watch(() => props.payload, (val) => {
  updateFields(val)
}, {
  immediate: true,
})

onMounted(() => {
  isShow.value = true
})

function updateFields(query) {
  fields.newCnt = query.new_cnt
  fields.deleteCnt = query.delete_cnt
}

function onShowNew() {
  router.push({name: "PromocodesListCouponNew"})
}

function onShowDelete() {
  router.push({name: "PromocodesListCouponDelete"})
}
</script>

<style src="./css/style.css" scoped />
